import gql from 'graphql-tag';
import FieldsCredit from 'graphql/fields/FieldsCredit';
import FieldsCreditAmount from 'graphql/fields/FieldsCreditAmount';

export default gql(`
	query employee_credit_amounts {
		employee_me {
			credit_amounts {
				${FieldsCreditAmount}
			}
		}
	}
`);

